'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = require('../constants');

var _util = require('../util');

exports.default = _extends({}, (0, _util.createActionObject)('authenticate', _constants.USER_AUTHENTICATE_START, _constants.USER_AUTHENTICATE_SUCCESS, _constants.USER_AUTHENTICATE_FAILURE), (0, _util.createActionObject)('register', _constants.USER_REGISTER_START, _constants.USER_REGISTER_SUCCESS, _constants.USER_REGISTER_FAILURE), (0, _util.createActionObject)('logout', _constants.USER_LOGOUT_START, _constants.USER_LOGOUT_SUCCESS, _constants.USER_LOGOUT_FAILURE), (0, _util.createActionObject)('loadCurrentUser', _constants.USER_LOAD_START, _constants.USER_LOAD_SUCCESS, _constants.USER_LOAD_FAILURE), (0, _util.createActionObject)('loadUserOrders', _constants.USER_LOAD_ORDERS_START, _constants.USER_LOAD_ORDERS_SUCCESS, _constants.USER_LOAD_ORDERS_FAILURE), (0, _util.createActionObject)('loadUserBookingRequests', _constants.USER_LOAD_BOOKING_REQUESTS_START, _constants.USER_LOAD_BOOKING_REQUESTS_SUCCESS, _constants.USER_LOAD_BOOKING_REQUESTS_FAILURE), (0, _util.createActionObject)('loadCreditCards', _constants.USER_LOAD_START, _constants.USER_LOAD_CREDIT_CARDS_SUCCESS, _constants.USER_LOAD_FAILURE), (0, _util.createActionObject)('deleteCreditCard', _constants.USER_LOAD_START, _constants.USER_DELETE_CREDIT_CARD_SUCCESS, _constants.USER_LOAD_FAILURE), {
  addNewTmpCreditCard: function addNewTmpCreditCard(data) {
    return {
      type: _constants.USER_ADD_TMP_NEW_CREDIT_CARD,
      data: data
    };
  },
  updateAccessToken: function updateAccessToken(accessToken) {
    return {
      type: _constants.USER_UPDATE_ACCESSTOKEN,
      accessToken: accessToken
    };
  },
  selectArchivedOrder: function selectArchivedOrder(orderId) {
    return {
      type: _constants.USER_SELECT_ARCHIVED_ORDER,
      orderId: orderId
    };
  },
  resetUserOrders: function resetUserOrders() {
    return {
      type: _constants.USER_RESET_ORDERS
    };
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-lib/lib/action/user.js
// module id = 426
// module chunks = 0